/** @format */

import { findLocalizedData } from '@/i18n/utils/find-localized-data';
import { TLocale } from '@/utils/gatsby/types';
import { TRoom } from './declarations';

export const utilityCalculateRoomURL = (locale: TLocale, room?: TRoom) => {
  if (!room) return '';
  // TODO: improve error handling, to be discussed
  if (room.localizedData.length === 0) {
    console.warn(`[LocalizedData]: missing localizedData in room ${room.code}`);
  }
  const localizedEntry = findLocalizedData(locale, room.localizedData);
  const url = localizedEntry?.url || '';
  const splitUrl = url.split('/');
  const part1 = splitUrl[4] || '';
  const part2 = splitUrl[5] || '';
  return `/${part1}/${part2}/`;
};

export const utilityCalculateRoomLocaleUrl = ({ room, intl }: { room?: TRoom; intl: TLocale }) => {
  if (!room) return '';

  const localizedData = findLocalizedData(intl, room.localizedData);
  if (!localizedData) return '';
  const splitUrl = localizedData.url.split('/');
  return `/${splitUrl[4]}/${splitUrl[5]}/`;
};

export const utilityCalculateRoomLocaleFullUrl = ({ room, intl }: { room?: TRoom; intl: TLocale }) => {
  if (!room) return '';

  const localizedData = findLocalizedData(intl, room.localizedData);
  if (!localizedData) return '';
  return localizedData.url;
};

export const utilityGetRoomMetaTag = (locale: TLocale, localizedData?: TRoom['localizedData']) => {
  if (!localizedData) {
    console.error('ATTENTION: called utilityGetRoomMetaTag without passing Room object');
    return { metaTitle: '', metaDescription: '' };
  }
  if (localizedData.length === 0) {
    console.warn(`[utilityGetRoomMetaTag]: missing localizedData`);
  }
  const intlObj = findLocalizedData(locale, localizedData);
  return { metaTitle: intlObj?.metaTitle || '', metaDescription: intlObj?.metaDescription || '' };
};

export const utilityGetRoomTitle = (locale: TLocale, localizedData?: TRoom['localizedData']) => {
  if (!localizedData) {
    console.error('ATTENTION: called utilityGetRoomTitle without passing Room object');
    return { title: '' };
  }
  if (localizedData.length === 0) {
    console.warn(`[utilityGetRoomTitle]: missing localizedData`);
  }
  const intlObj = findLocalizedData(locale, localizedData);
  return { title: intlObj?.title || '' };
};

export const utilityGetRoomDescription = (locale: TLocale, localizedData?: TRoom['localizedData']) => {
  if (!localizedData) {
    console.error('ATTENTION: called utilityGetRoomDescription without passing Room object');
    return { description: '' };
  }
  if (localizedData.length === 0) {
    console.warn(`[utilityGetRoomDescription]: missing localizedData`);
  }
  const intlObj = findLocalizedData(locale, localizedData);
  return { description: intlObj?.description || '' };
};
